import { useState, useEffect } from 'react';
import { FaTag } from 'react-icons/fa';
import CircleIcon from 'components/CircleIcon';
import SectionTitle from 'components/typography/SectionTitle';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import ExtrasItem from './ExtrasItem';

export default function Extras({ extrasList = [] }) {
  const [isLoyaltyExtra, setIsLoyaltyExtra] = useState(false);
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();

  useEffect(() => {
    const foundLoyalty = extrasList.some(extra => extra.loyalty === true);
    setIsLoyaltyExtra(foundLoyalty);
  }, [extrasList]);

  return (
    <>
      <div className="mt-[60px] lg:mt-[40px] flex items-start">
        <CircleIcon className="mt-1" iconClassName="text-lg">
          <FaTag style={{ fill: primaryColour }} />
        </CircleIcon>
        <SectionTitle label={isLoyaltyExtra ? "Bundle Items" : "Inclusions"} className="ml-[10px] mt-1" />
      </div>
      {extrasList.map((extra, index) => (
        <div key={`${index + 1}`} className="mt-[40px]">
          <ExtrasItem extra={extra} isLoyaltyExtra={isLoyaltyExtra} />
        </div>
      ))}
    </>
  );
}
